import { testimonials } from '@/mocks/content';

export default function TestimonialSection() {
  return (
    <section id="avaliacoes" className="relative w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            Avaliações
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            O que dizem<br />
            <span className="text-accent-500">nossos usuários</span>
          </h2>
        </div>

        {/* Testimonial Cards Masonry */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-background-50 border border-background-200/60 rounded-2xl p-6 flex flex-col gap-4"
            >
              {/* User Info */}
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0">
                  <span className="text-secondary-700 font-bold text-sm">{t.name.charAt(0)}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-foreground-950 font-semibold text-sm">{t.name}</span>
                  <span className="text-foreground-500 text-xs">{t.username}</span>
                </div>
              </div>

              {/* Stars */}
              <div className="flex gap-0.5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-yellow-500 text-sm"></i>
                  </span>
                ))}
              </div>

              {/* Text */}
              <p className="text-foreground-600 text-sm leading-relaxed">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}